// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mJ-z","isFullWidth":"nJ-z","landingPageVideo":"oJ-z","play":"pJ-z","iframeVideo":"qJ-z","playHidden":"rJ-z","fullwidth":"sJ-z"};